// extracted by mini-css-extract-plugin
export default {"block":"NotFound_block__A5KMk"};